import { render } from "./PlacementView.vue?vue&type=template&id=0053d042"
import script from "./PlacementView.vue?vue&type=script&lang=js"
export * from "./PlacementView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__